/*
 * Container Messages
 *
 * This contains all the text for the Container.
 */

import { defineMessages } from 'react-intl';

export const scope = 'app.containers.LoginPage';

export default defineMessages({
  defaultPageTitle: {
    id: `${scope}.defaultPageTitle`,
    defaultMessage: 'CIAS EU',
  },
});
